import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bind from 'lodash-decorators/bind';
import { arc as d3Arc } from 'd3-shape';

export default class Arc extends PureComponent {
  arcRef = null;
  labelRef = null;

  static propTypes = {
    borderSize: PropTypes.number.isRequired,
    borderColor: PropTypes.string.isRequired,
    labelColor: PropTypes.string.isRequired,
    labelFontSize: PropTypes.number.isRequired,
    arcSize: PropTypes.number.isRequired,
    arcColor: PropTypes.string.isRequired,
    radius: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const arc = d3Arc()
      .outerRadius(props.radius - props.borderSize)
      .innerRadius(props.radius - props.borderSize - props.arcSize);

    const arcBorder = d3Arc()
      .outerRadius(props.radius)
      .innerRadius(props.radius - 2 * props.borderSize - props.arcSize);

    const insideTranslate = arc.centroid(props.data);
    const translate = props.isHoverEnable
      ? this.outsideTranslate(
          insideTranslate[0],
          insideTranslate[1],
          props.borderSize,
          props.radius
        )
      : insideTranslate;

    this.state = {
      arc,
      arcBorder,
      translate
    };
  }

  @Bind()
  setArcRef(ref) {
    this.arcRef = ref;
  }

  @Bind()
  setLabelRef(ref) {
    this.labelRef = ref;
  }

  outsideTranslate = (x, y, borderSize, radius) => {
    const h = Math.sqrt(x * x + y * y);
    const space = radius + borderSize;
    return `${(x / h) * space}, ${(y / h) * space}`;
  };

  render() {
    const { arc, arcBorder, translate } = this.state;

    const {
      arcColor,
      borderColor,
      labelColor,
      labelFontSize,
      data
    } = this.props;

    const labelStyle = {
      fontSize: labelFontSize,
      fontWeight: 400
    };

    return (
      <g>
        <path fill={borderColor} d={arcBorder(data)} />
        <path fill={arcColor} d={arc(data)} ref={this.setArcRef} />
        <text
          style={labelStyle}
          fill={labelColor}
          textAnchor="middle"
          alignmentBaseline="central"
          transform={`translate(${translate})`}
          ref={this.setLabelRef}
        >
          {data.value}%
        </text>
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/DonutChart/Arc.js